import * as React from "react";
import { FileCode2 } from "lucide-react";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export function McpRequestDialog() {
  const [open, setOpen] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const name = String(fd.get("name") ?? "").trim();
    const company = String(fd.get("company") ?? "").trim();
    const email = String(fd.get("email") ?? "").trim();
    if (!name || !company || !email) {
      toast.error("Please fill in all fields.");
      return;
    }
    setSubmitting(true);
    setTimeout(() => {
      toast.success("Thanks — we'll send the MCP access details shortly.");
      form.reset();
      setSubmitting(false);
      setOpen(false);
    }, 400);
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center gap-2 rounded-md border border-white/20 bg-white/5 px-5 py-2.5 text-sm font-medium text-white hover:bg-white/10 transition-colors font-mono"
        >
          <FileCode2 className="size-4" aria-hidden />
          Get the Axy.digital Market Intelligence MCP
        </button>
      </DialogTrigger>
      <DialogContent className="border-white/10 bg-background text-white">
        <DialogHeader>
          <DialogTitle>Get the Axy.digital Market Intelligence MCP</DialogTitle>
          <DialogDescription className="text-white/65">
            Tell us a bit about you and we'll send access details for the MCP server.
          </DialogDescription>
        </DialogHeader>
        <form className="space-y-4" onSubmit={handleSubmit}>
          <div className="space-y-1.5">
            <Label htmlFor="mcp-name">Name</Label>
            <Input id="mcp-name" name="name" required maxLength={120} autoComplete="name" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="mcp-company">Company name</Label>
            <Input id="mcp-company" name="company" required maxLength={160} autoComplete="organization" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="mcp-email">Work email</Label>
            <Input id="mcp-email" name="email" type="email" required maxLength={255} autoComplete="email" />
          </div>
          <Button type="submit" className="w-full h-11" disabled={submitting}>
            {submitting ? "Sending…" : "Request access"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
